/**
 * Constants for Spaces redirection button tags
 * Maps page routes to their corresponding dashboard tags
 */
export const SPACES_TAG_MAPPING = {
  DATASETS: 'datasets',
  QUERY: 'query', 
  WORKLOADS: 'workloads',
  WAREHOUSE: 'warehouse',
  USERS: 'users',
} as const;

export type SpacesTag = typeof SPACES_TAG_MAPPING[keyof typeof SPACES_TAG_MAPPING];
